import React, { Fragment, PureComponent } from 'react'
import TicketPreview from '../TicketPreview'

const previewWaitShow = 500
let previewHandle = null

export default function withTicketPreview(
  WrappedComponent,
  eventsOnly = false
) {
  return class extends PureComponent {
    delayedShowTicketPreviewModal = e => {
      const {
        showTicketPreviewModal,
        ticketId,
        eventOffsetRight,
        disabled,
      } = this.props
      if (disabled) return
      if (previewHandle) clearTimeout(previewHandle)
      const offset = { left: e.pageX, top: e.pageY, eventOffsetRight }
      previewHandle = setTimeout(() => {
        showTicketPreviewModal(ticketId, offset)
      }, previewWaitShow)
    }

    cancelDelayedShowTicketPreviewModal = () => {
      const { disabled } = this.props
      if (disabled) return
      if (previewHandle) clearTimeout(previewHandle)
    }

    render() {
      const { ticketId, disabled } = this.props
      return (
        <Fragment>
          <WrappedComponent
            {...this.props}
            delayedShowTicketPreviewModal={this.delayedShowTicketPreviewModal}
            cancelDelayedShowTicketPreviewModal={
              this.cancelDelayedShowTicketPreviewModal
            }
          />
          {!eventsOnly &&
            !disabled && (
              <TicketPreview
                key={`ticket-preview-${ticketId}`}
                showState
                showMark
                ticketId={ticketId}
              />
            )}
        </Fragment>
      )
    }
  }
}
